export enum Character {
  Frodo = 'Frodo',
  Sam = 'Sam',
  Merry = 'Merry',
  Pippin = 'Pippin',
  Boromir = 'Boromir',
  Aragorn = 'Aragorn',
  Gimli = 'Gimli',
  Legolas = 'Legolas',
  Gandalf = 'Gandalf'
}